import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { Development, DevelopmentDetailType } from 'types/promoters/promoterTypes';
import {
  FilterType,
  GetPropertyType,
  InitialViewType,
  PropertyType,
} from 'types/property/propertyTypes';

export type PropertySliceType = {
  activeProperty?: PropertyType;
  watchedProperties?: GetPropertyType[];
  terms?: FilterType;
  activeDevelopment?: DevelopmentDetailType;
  developmentList?: Development[];
  initialView?: InitialViewType;
};

export const initialState: PropertySliceType = {
  watchedProperties: undefined,
};

export const propertySlice = createSlice({
  name: 'propertySlice',
  initialState,
  reducers: {
    setActiveProperty: (state, action: PayloadAction<PropertyType | undefined>) => {
      state.activeProperty = action.payload;
    },
    setActiveDevelopment: (state, action: PayloadAction<DevelopmentDetailType | undefined>) => {
      state.activeDevelopment = action.payload;
    },
    setDevelopmentList: (state, action: PayloadAction<Development[] | undefined>) => {
      state.developmentList = action.payload;
    },
    setInitialView: (state, action: PayloadAction<InitialViewType | undefined>) => {
      state.initialView = action.payload;
    },
    setTerms: (state, action: PayloadAction<Partial<FilterType> | undefined>) => {
      if (action.payload === undefined) {
        state.terms = undefined;
        return;
      }

      state.terms = {
        ...state.terms,
        ...action.payload,
      };
    },
    updateDevelopments: (state, action: PayloadAction<Development>) => {
      const index = state.developmentList?.findIndex((p) => p.id === action.payload.id);
      if (index !== undefined && index !== -1 && state.developmentList) {
        state.developmentList[index] = action.payload;
      } else {
        state.developmentList?.push(action.payload);
      }
    },
    removeDevelopmentById: (state, action) => {
      const idToRemove = action.payload; // Get the id passed in the action
      state.developmentList = state.developmentList?.filter((dev) => dev.id !== idToRemove);
    },
    setWatchedProperties: (state, action: PayloadAction<GetPropertyType[] | undefined>) => {
      state.watchedProperties = action.payload;
    },
  },
});

export const {
  setActiveProperty,
  setDevelopmentList,
  setWatchedProperties,
  setActiveDevelopment,
  setTerms,
  setInitialView,
  removeDevelopmentById,
  updateDevelopments,
} = propertySlice.actions;
